import TableCell from '@mui/material/TableCell'

import type { Campaign } from '../../types'

import { formatPercent } from './LastCells'

export function CommonCells({ statistics }: Pick<Campaign, 'statistics'>) {
	return [
		<TableCell
			className='contacts   text-accent'
			key='i'
			style={{ width: '10%' }}
		>
			{statistics.invitation_sent}
		</TableCell>,

		<TableCell className='contacts' key='a' style={{ width: '10%' }}>
			<div className='start-wrapper-accent'>
				<div className='start-end-date text-accent'>
					{formatPercent(statistics.acceptance_rate)}
				</div>
			</div>
		</TableCell>,

		<TableCell
			className='contacts   text-accent'
			key='m'
			style={{ width: '10%' }}
		>
			{statistics.messages_sent}
		</TableCell>
	]
}
